import { render, staticRenderFns } from "./VipMain.vue?vue&type=template&id=7c6e06ba&scoped=true&"
import script from "./VipMain.vue?vue&type=script&lang=ts&"
export * from "./VipMain.vue?vue&type=script&lang=ts&"
import style0 from "./VipMain.vue?vue&type=style&index=0&id=7c6e06ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6e06ba",
  null
  
)

export default component.exports